import { useEffect } from "react";

/**
 * Tiny redirect — sends visitors of /inversores to the static HTML pitch deck.
 * Replace (not push) so the browser back button works correctly.
 */
const InversoresRedirect = () => {
  useEffect(() => {
    window.location.replace("/inversores.html");
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0a0a14",
      color: "#c9a227",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando…
    </div>
  );
};

export default InversoresRedirect;
